import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { LoginServiceService } from "../../Services/login-service.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "b2b-login",
  templateUrl: "./b2b-login.component.html",
  styleUrls: ["./b2b-login.component.css"],
})
export class B2bLoginComponent implements OnInit {
  public form: FormGroup;
  public loggedIn: boolean;
  public showLogin: boolean;

  constructor(
    private service: LoginServiceService,
    private toastr: ToastrService,
    private _route: Router,
    private spinner: NgxSpinnerService
  ) {
    this.form = this.createFormGroup();
  }

  ngOnInit() {
    if (localStorage.getItem("b2buser")) {
      this.loggedIn = true;
      this.showLogin = true;
      this._route.navigate(["/sales/b2bLanding"]);
    } else {
      this.loggedIn = false;
      this.showLogin = false;
    }
  }

  createFormGroup() {
    return new FormGroup({
      user: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  formSubmit() {
    this.spinner.show();
    const base64Creds = btoa(
      `${this.form.value.user}:${this.form.value.password}`
    );
    localStorage.setItem("authCreds", base64Creds);
    this.service
      .validateB2BUser(this.form.value.user, this.form.value.password)
      .subscribe(
        (response: any) => {
          if (response["success"] == "true") {
            this.spinner.hide();
            console.log("response", response);
            localStorage.setItem("b2buser", this.form.value.user);
            localStorage.setItem("b2btype", response.data[0].WHTYPE);
            this.loggedIn = true;
            this.showLogin = true;
            this._route.navigate(["/sales/b2bLanding"]);
          } else {
            this.spinner.hide();
            this.toastr.error("Invalid login", "Error");
            this.loggedIn = false;
            this.showLogin = false;
          }
        },
        (error) => {
          this.spinner.hide();
          console.log("error", error);
          if (error.statusText == "Unauthorized") 
            this.toastr.error("Invalid login", "Error", {
            timeOut: 5000,
            });
          else
            this.toastr.error("Unexpected error occurred", "Error", {
            timeOut: 5000,
          });
          this.loggedIn = false;
          this.showLogin = false;
        }
      );
  }
}
